export default __webpack_public_path__ + "static/media/ksponsor-bg.dd77b1b3.png";